import REST from '../rest';

const ENDPOINT = (reportId) => `api/v1/reports/${reportId}/filters`;

const PAGE_SIZE = 5;

export const load = (reportId, filterId) => REST.get(
  ENDPOINT(reportId),
  filterId,
  { page: { number: 1, size: PAGE_SIZE } },
);

export default 'load';
